<template>
  <div class="home-container">
    <SearchBar :aisShipList="aisShipList"
                ref="SearchBar"
               :allGroupListData="allGroupListData"></SearchBar>
    <Map :clientWidth="clientWidth"
         :clientHeight="clientHeight"
         :currentShipData="currentShipData"
         :allGroupListData="allGroupListData"
         @closePlay="closePlay"
         :aisShipList="aisShipList"
         @setViewer="setViewerHandler"
         >
    </Map>
    <Left :clientWidth="clientWidth"
          :clientHeight="clientHeight"
          :mmsi="mmsi"
          :shipName="currentName"
          :currentAisShipData="currentAisShipData"
          :currentShipData="currentShipData"
          :crewInfo="crewInfo"
          :changeWidth="timer"
          :manageInfo="manageInfo">
    </Left>
    <User></User>
    <!--<Right :clientWidth="clientWidth"
           :clientHeight="clientHeight"
           :mmsi="mmsi"
           :shipName="currentName"
           :currentAisShipData="currentAisShipData"
           :currentShipData="currentShipData"
           :portInfoData="portInfoData"
           :goodsColor="goodsColor"
           :changeWidth="timer"
           :goodsProportionData="goodsProportionData"
           :goodsStowageData="goodsStowageData"
           :viewer="viewer">
    </Right>-->
    <BottomBar v-if="showWeatherIcons"></BottomBar>
  </div>

</template>

<script>
import { defineComponent } from "vue";
import Map from "./map/map.vue";
import Left from "./left.vue";
//import Right from "./right.vue";
import User from "./user.vue";
import SearchBar from "./search.vue";
import BottomBar from "./bottomItem";
import moment from "moment";
import store from "@/store/index";
import { mapGetters } from "vuex";
import { getShips } from "../api/modules/proxy";

import {
  getShipInfo,
  getStowageInfo,
  getPortInfo,
  getShipList,
} from "../api/modules/addition";

export default defineComponent({
  name: "HomePage",
  components: { Map, Left, User, SearchBar, BottomBar },
  data() {
    return {
      viewer: {},
      clientWidth: document.body.clientWidth,
      clientHeight: document.body.clientHeight,
      mmsiArray: [],
      aisShipList: [],
      allGroupListData: {},
      currentMmsi: "",
      currentName: "",
      currentAisShipData: {},
      currentShipData: {},
      crewInfo: {},
      manageInfo: {},
      portInfoData: [], //港口数据
      goodsProportionData: [], //货物配比数据
      goodsStowageData: [], //船舱货物数据
      goodsColor: [], //货物对应颜色
      timer: false, //计时
      voyage_code: "", //航次编码
    };
  },
  computed: {
    ...mapGetters(["mmsi", "costMonth", "showWeatherIcons", "selectedGoods","noAisShipList"]),
  },
  mounted() {
    this.getGroupList();
    this.getAisShipList();
    const that = this;
    let month = moment().format("YYYYMM");
    store.dispatch("SET_COST_MONTH", month);
    window.onresize = () => {
      return (() => {
        window.clientWidth = document.body.clientWidth;
        that.clientWidth = document.body.clientWidth;
      })();
    };
    document.addEventListener("click", (e) => {
      if (this.selectedGoods != "" && e.target.id == "port") {
        store.dispatch("SET_SELECTED_GOODS", "");
      }
    });
  },
  watch: {
    mmsi(newV) {
      if (newV) {
        if(this.noAisShipList.indexOf(newV) > -1){
          this.currentAisShipData={}
          this.currentName = this.allGroupListData.default_order.filter((item) => {
            return item.mmsi === newV;
          })[0].name;
           this.clearSelect();
          this.getShipInfo(this.currentName);
          // console.log("ccc",this.currentName);
        }
        else{
          this.currentAisShipData = this.aisShipList.filter((item) => {
            return item.mmsi === newV;
          })[0];
          this.currentName = this.currentAisShipData.name;
          this.clearSelect();
          this.getShipInfo(this.currentName);
        // this.getPortInfo(this.currentName);
        // this.getGoodsData(this.currentName);
        // this.getAdditionData(newV);
          
        }
      }
    },
    // costMonth(newV) {
    //   this.getCostInfo(this.currentName);
    // },
    selectedGoods() {
      this.getPortInfo(this.currentName);
      // this.getGoodsData(this.currentName);
    },
    clientWidth(newV) {
      if (!this.timer) {
        this.timer = true;
        let that = this;
        setTimeout(function () {
          that.timer = false;
        }, 400);
      }
    },
  },
  methods: {
    setViewerHandler(obj) {
      this.viewer = obj
    },
    clearSelect() {
      store.dispatch("SET_SELECTED_GOODS", "");
    },
    async getGroupList() {
      const params = {
        size: 10000,
        page: 1,
        operational_status: '运营中'
      };
      this.mmsiArray = [];
      await getShipList(params).then((res) => {
        this.allGroupListData = res.data;
        if (
          this.allGroupListData.default_order &&
          this.allGroupListData.default_order.length > 0
        ) {
          this.allGroupListData.default_order.forEach((item) => {
            this.mmsiArray.push(item.mmsi);
          });
        }
      });
    },
    async getAisShipList() {
      /**if (!getMeteoToken()) {
        await store.dispatch("GET_METEO_TOKEN");
      }**/
      // await this.getGroupList();
      // const array = [
      //   477669300, 477669200, 477159300, 636019987, 636019988, 636019989,
      //   636019990, 636019991, 636019992, 636019994, 636019995, 538006131,
      //   538006132, 636019743, 636018944, 636018945, 538003913,
      // ];
      // const shipsMmsi = this.mmsiArray || array;

      // const shipsMmsiStr = shipsMmsi.toString();
      // const params = {
      //   mids: shipsMmsiStr,
      // };
      getShips().then((res) => {
        // console.log(res)
        const data = res.data;
        this.aisShipList = data;
        store.dispatch("SET_AIS_SHIP_LIST", this.aisShipList);

        this.currentAisShipData =
          this.aisShipList.filter((item) => {
            return item.name === "SOLAR CHERYL";
          })[0] || this.aisShipList[0];
        this.currentMmsi = this.currentAisShipData.mmsi;
        this.currentName = this.currentAisShipData.name;
        // store.dispatch("SET_MMSI", this.currentMmsi);
      });
    },
    // 获取dispathc接口的船舶数据
    async getShipInfo(shipName) {
      // console.log(shipName)
      let params = {
        tanker_name: shipName,
      };
      await getShipInfo(params)
        .then((res) => {
          this.currentShipData = res.data;
          store.dispatch("SET_CURRENT_SHIP_DATA", res.data);
          this.voyage_code = res.data.noon_report.voyage_code
            ? res.data.noon_report.voyage_code
            : "";
          this.getPortInfo(this.currentName);
          this.getGoodsData(this.currentName);
          let crew_info = res.data.crew_info;
          this.crewInfo = {
            allCrewCount: crew_info.all_crew_count || 0,
            allCrewLi: crew_info.all_crew_li || [],
            thirtyOffCount: crew_info.thirty_off_count || 0,
            thirtyOff: crew_info.thirty_off || [],
            thirtyOnCount: crew_info.thirty_on_count || 0,
            thirtyOn: crew_info.thirty_on || [],
            overdueCount: crew_info.overdue_count || 0,
            overdueLi: crew_info.overdue || [],
            elevenMonthsOnBoardCount: crew_info.eleven_months_on_board_count || 0,
            elevenMonthsOnBoard: crew_info.eleven_months_on_board || []
          };
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 获取管理成本
    // async getCostInfo(shipName) {
    //   // console.log(shipName)
    //   let params = {
    //     tanker_name: shipName,
    //     month: this.costMonth,
    //   };
    //   await getCostInfo(params)
    //     .then((res) => {
    //       this.manageInfo = {
    //         budgetList: {
    //           isNull: res.budget ? false : true,
    //           data: res.budget || 0,
    //         },
    //         costList: {
    //           isNull: res.cost ? false : true,
    //           data: res.cost || 0,
    //         },
    //         usageList: {
    //           isNull: res.usage ? false : true,
    //           data: res.usage || 0,
    //         },
    //       };
    //     })
    //     .catch((err) => {
    //       console.log(err);
    //     });
    // },
    // // 获取船舶附加信息（管理成本、船员信息）
    // async getAdditionData(mmsi) {
    //   const params = {
    //     mmsi_code: mmsi,
    //     size: 100,
    //     page: 1,
    //   };
    //   await getAdditionList(params).then((res) => {
    //     const list = res.data.voyage_li;
    //     // store.dispatch("SET_ADDITION_LIST", this.additionList);
    //     const curShipAddition = list && list.length > 0 ? list[0] : {};
    //   });
    // },
    // 获取港口信息
    async getPortInfo(shipName) {
      let that = this;
      if (this.selectedGoods == "") {
        let params = {
          tanker_name: shipName,
          cargo_name: that.selectedGoods,
          voyage_code: that.voyage_code,
        };
        await getPortInfo(params)
          .then((res) => {
            that.portInfoData = res.data.ports;
          })
          .catch((err) => {
            // console.log(err);
          });
        // console.log(this.portInfoData);
      } else {
        let params = {
          tanker_name: shipName,
          cargo_name: that.selectedGoods,
        };
        await getPortInfo(params)
          .then((res) => {
            that.portInfoData = res.data.ports_with_cargo;
          })
          .catch((err) => {
            // console.log(err);
          });
      }
    },
    // 获取货物数据
    async getGoodsData(shipName) {
      let color = [
        "#5b90fa",
        "#59d8a6",
        "#5d7091",
        "#f6bd16",
        "#6442a9",
        "#6ec8eb",
        "#916fc6",
        "#ff9d4c",
        "#269a99",
        "#cd99fe",
        "#5a67fb",
        "#bdd1fc",
      ];
      let params = {
        tanker_name: shipName,
        voyage_code: this.voyage_code,
      };
      // 货物配比
      let goodsData = [];
      // 港口信息
      let shipGoods = [];
      await getStowageInfo(params)
        .then((res) => {
          // console.log(res,'goodsStowageData')
          // 货物配比
          // console.log('res',res)
          res.data.cargo.forEach((item) => {
            let condition = {
              name: item[0] ? item[0] : "",
              value: item[1] ? parseFloat(item[1]).toFixed(2) : 0,
            };
            // console.log(condition);
            goodsData.push(condition);
          });
          // 货仓数据
          shipGoods[0] = res.data.stowage_above;
          shipGoods[1] = res.data.stowage_below;
          // 货物颜色
          // console.log('goodsData',goodsData)
          goodsData.forEach((item, index) => {
            item.color = color[index];
          });
          // 货仓颜色
          for (let i = 0; i < shipGoods.length; i++) {
            shipGoods[i].forEach((goods) => {
              let flag = false;
              goodsData.forEach((item) => {
                if (goods.cargo_name == item.name) {
                  goods.color = item.color;
                  flag = true;
                }
              });
              if (flag == false) {
                goods.color = "#b1b1b1";
                // console.log(goods);
              }
            });
          }
        })
        .catch((err) => {
          // console.log(err);
        });

      this.$nextTick(() => {
        this.goodsColor = color;
        this.goodsProportionData = goodsData;
        this.goodsStowageData = shipGoods;
      });
    },
    // 触发关闭自动播放
    closePlay(mmsi) {
      this.$refs.SearchBar.closePlay(mmsi)
    }
  },
});
</script>

<style lang="scss">
.home-container {
  height: 100%;
  width: 100%;
  overflow: hidden;
  background: url("../assets/png/bg-1920.png") center center no-repeat;
  background-size: cover;
}
</style>
